<template>
    <div class="full-width">
        <img src="../../../../assets/resource/img/total-search--back.png" alt="" class="full-width--bg">
        <div class="total-search-wrap">
            <div class="total-search__top">
                <div class="total-search">

                    <input type="text" class="total-search--input" ref="searchInput" placeholder="검색어를 입력하세요." v-model="searchKeywordText" @keyup.enter="searchEvent" v-if="!inSearch">
                    <input type="text" class="total-search--input" ref="searchInput" placeholder="재 검색어를 입력해주세요." v-model="inSearchKeywordText" @keyup.enter="searchEvent" v-if="inSearch">

                    <a href="javascript:;" class="total-search--btn" @click="searchEvent()"></a>
                </div>

                <div class="radio-wrap"  v-if="inSearchKeyword === ''">
                    <label  >
                        <input type="checkbox" name="test01" id="test01" v-model="inSearch">
                        <span class="radio-btn"></span>
                        <p>결과내 재검색</p>
                    </label>
                </div>
                <!-- 재검색 시 재검색 체크박스가 사라지고 밑에 버튼이 나옴 -->
                <a href="javascript:;" class="main-button small c-gray" v-if="inSearchKeyword !== ''" @click="clearSearch">재 검색 취소</a>
            </div>
            <ul class="total-search__list">
                <li class="total-search__item" v-for="(hashtag, index) in hashTags" :key="index">
                    <a href="javascript:;" @click="[moveTab('total'), search(hashtag.codeName)]">#{{hashtag.codeName}}</a>
                </li>
            </ul>
            <h4 class="title02" v-if="totCnt !== 0 && !searching">“<span>{{ searchKeyword }}</span><span v-if="inSearchKeyword !== ''"> >> {{ inSearchKeyword }}</span>”에 대한 총 <span>{{ totCnt }}</span>건이 검색되었습니다.</h4>
            <h4 class="title02" v-else-if="searching">“<span>{{ searchingKeyword }}</span>”에 대해 검색중입니다.</h4>
            <h4 class="title02" v-else>“<span>{{ searchKeyword }}</span>”에 대한 검색 결과가 없습니다.</h4>
        </div>
    </div>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item" :class="{active : selectTab === 'total'}">
                <a href="javascript:;" @click="moveTab('total')">통합검색 ({{ totCnt }})</a>
            </li>
            <li class="tab-menu__item" :class="{active : selectTab === 'center'}">
                <a href="javascript:;" @click="moveTab('center')"> 센터 ({{ centerResult.totCnt }}) </a>
            </li>
            <li class="tab-menu__item" :class="{active : selectTab === 'doctor'}">
                <a href="javascript:;" @click="moveTab('doctor')"> 의료진 ({{ doctorResult.totCnt }}) </a>
            </li>
            <li class="tab-menu__item" :class="{active : selectTab === 'reserve'}">
                <a href="javascript:;" @click="moveTab('reserve')"> 예약/발급 ({{ reserveResult.totCnt }}) </a>
            </li>
            <li class="tab-menu__item" :class="{active : selectTab === 'info'}">
                <a href="javascript:;" @click="moveTab('info')"> 이용안내 ({{ infoResult.totCnt }}) </a>
            </li>
            <li class="tab-menu__item" :class="{active : selectTab === 'health'}">
                <a href="javascript:;" @click="moveTab('health')"> 건강정보 ({{ healthResult.totCnt }}) </a>
            </li>
            <li class="tab-menu__item" :class="{active : selectTab === 'intro'}">
                <a href="javascript:;" @click="moveTab('intro')"> 병원소개 ({{ introResult.totCnt }}) </a>
            </li>
        </ul>
    </div>

    <div class="total-search__cont">
        <!-- 검색어 없을시 -->
        <div class="total-search__box" v-if="(this.$data[`${searchType}Result`] && this.$data[`${searchType}Result`].totCnt === 0) || totCnt == 0">
            <p class="bullet03">검색어가 바르게 입력 되었는지 확인해 주세요.</p>
            <p class="bullet03">검색어의 띄어쓰기를 정확하게 한 후 검색해 주세요.</p>
            <p class="bullet03">검색어에 영어나 특수문자를 제거 한 후 검색해 주세요.</p>
        </div>

        <!-- 통합검색 -->

        <!-- 센터 -->
        <div class="total-search__box" v-if="centerResult.totCnt !== 0 && (selectTab === 'total' || selectTab === 'center')">
            <div class="total-search__header">
                <h4 class="title03">센터 (총 {{ centerResult.totCnt }}건)</h4>
                <a href="javascript:;" class="total-search__header--link" @click="moveTab('center')" v-if="searchType === 'total'">더보기</a>
            </div>
            <div class="total-search__body">
                <ul class="total-search__list">
                    <li class="total-search__item" v-for="(center, index) in centerResult.list" :key="index">
                        <router-link class="total-search__item--link" :to="`/kr/center?deptCd=${center.deptCd}`">
                            <div class="total-search__img-wrap">
                                <div class="total-search__img">
                                    <h4 class="title03 show-mo" v-html="setHighlightText(center.deptNm)"></h4>
                                    <img :src="`/displayFile.do?name=${center.thumbAttach.savedName}`" alt="">
                                </div>
                            </div>
                            <div class="total-search__text">
                                <h4 class="title03" v-html="setHighlightText(center.deptNm)"></h4>
                                <p v-html="setHighlightText($commonUtils.removeTags(center.copyTxt))">
                                </p>
                                <sub>
                                    센터/의료진
                                </sub>
                            </div>
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>

        <!-- 의료진 -->
        <div class="total-search__box" v-if="doctorResult.totCnt !== 0 && (selectTab === 'total' || selectTab === 'doctor')">
            <div class="total-search__header">
                <h4 class="title03">의료진 (총 {{doctorResult.totCnt}}건)</h4>
                <a href="javascript:;" class="total-search__header--link" @click="moveTab('doctor')" v-if="searchType === 'total'">더보기</a>
            </div>
            <div class="total-search__body">
                <!-- 의료진 단독일때 -->
                <div class="word-search__btn type2" v-if="searchType === 'doctor'">
                    <h5 class="title02">초성검색</h5>
                    <ul class="word-search__list">
                        <!-- 선택시 : active -->
                        <li :class="{'word-search__item': true, 'active': !searchChosung}">
                            <button type="button" class="btn" @click="[searchConsonant('')]">전체</button>
                        </li>
                        <li class="word-search__item" :class="{'active': searchChosung === consonant.searchText }" v-for="(consonant, index) in consonantList" :key="index">
                            <button type="button" class="btn" @click="searchConsonant(consonant.searchText)" :class="consonant.disable">{{ consonant.cho }}</button>
                        </li>
                    </ul>
                </div>

                <ul class="doctor-list">
                    <li class="doctor-list__item" v-for="(doctor, index) in doctorResult.list" :key="index">
                        <div class="doctor-list--img">
                            <img :src="`/displayFile.do?drSid=${doctor.drSid}`" alt="이미지" onerror="this.style.display='none'">
                        </div>
                        <div class="doctor-list--con">
                            <div class="doctor-list--text">
                                <h3 class="doctor-list--name" v-html="`${setHighlightText(doctor.name)} 교수`"></h3>
                                <p class="doctor-list--department">{{ doctor.belong }}</p>

                                <h4 class="doctor-list--clinic">전문진료분야</h4>
                                <p class="doctor-list--desc" v-html="setHighlightText(doctor.detailField)"></p>
                            </div>
                            <div class="doctor-list--button">
                                <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'N')">진료예약</a>
                                <a href="javascript:;" @click="getDoctorReserveDate(doctor, 'Q')">빠른예약</a>
                                <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.mainDeptCd}`" target="_blank">의료진소개</a>
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- 의료진 단독일때 -->
                <template v-if="selectTab === 'doctor'">
                    <kr_Pagination :totCnt="pageTotCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
                </template>
            </div>
        </div>

        <!-- 예약발급 -->
        <div class="total-search__box" v-if="reserveResult.totCnt !== 0 && (selectTab === 'total' || selectTab === 'reserve')">
            <div class="total-search__header">
                <h4 class="title03">예약발급 (총 {{reserveResult.totCnt}}건)</h4>
                <a href="javascript:;" class="total-search__header--link" @click="moveTab('reserve')" v-if="searchType === 'total'">더보기</a>
            </div>
            <div class="total-search__body">
                <ul class="total-search__list">
                    <li class="total-search__item" v-for="(article, index) in reserveResult.list" :key="index">
                        <router-link :to="article.link" class="total-search__item--link">
                            <div class="total-search__text">
                                <h4 class="title03" v-html="setHighlightText(article.TITLE)"></h4>
                                <p v-html="setHighlightText($commonUtils.removeTags(article.CONTENT))"></p>
                                <sub>
                                    {{ article.pathName }}
                                </sub>
                            </div>
                        </router-link>
                    </li>
                </ul>

                <template v-if="selectTab !== 'total'">
                    <kr_Pagination :totCnt="pageTotCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
                </template>
            </div>
        </div>

        <!-- 이용안내 -->
        <div class="total-search__box" v-if="infoResult.totCnt !== 0 && (selectTab === 'total' || selectTab === 'info')">
            <div class="total-search__header">
                <h4 class="title03">이용안내 (총 {{infoResult.totCnt}}건)</h4>
                <a href="javascript:;" class="total-search__header--link" @click="moveTab('info')" v-if="searchType === 'total'">더보기</a>
            </div>
            <div class="total-search__body">
                <ul class="total-search__list">
                    <li class="total-search__item" v-for="(article, index) in infoResult.list" :key="index">
                        <router-link :to="article.link" class="total-search__item--link">
                            <div class="total-search__text">
                                <h4 class="title03" v-html="setHighlightText(article.TITLE)"></h4>
                                <p v-html="setHighlightText($commonUtils.removeTags(article.CONTENT))"></p>
                                <sub>
                                    {{ article.pathName }}
                                </sub>
                            </div>
                        </router-link>
                    </li>
                </ul>

                <template v-if="selectTab !== 'total'">
                    <kr_Pagination :totCnt="pageTotCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
                </template>
            </div>
        </div>

        <!-- 건강정보 -->
        <div class="total-search__box" v-if="healthResult.totCnt !== 0 && (selectTab === 'total' || selectTab === 'health')">
            <div class="total-search__header">
                <h4 class="title03">건강정보 (총 {{healthResult.totCnt}}건)</h4>
                <a href="javascript:;" class="total-search__header--link" @click="moveTab('health')" v-if="searchType === 'total'">더보기</a>
            </div>
            <div class="total-search__body">
                <ul class="total-search__list">
                    <li class="total-search__item" v-for="(article, index) in healthResult.list" :key="index">
                        <router-link :to="article.link" class="total-search__item--link">
                            <div class="total-search__img" v-if="article.link.indexOf('health_dic') == -1">
                                <img :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(article)}/mqdefault.jpg`" alt="이미지" v-if="article.LINK_URL && article.LINK_URL.indexOf('youtu') > -1">
                                <img :src="`/displayFile.do?attachNo=${ article.ATTACH_NO }`" alt="이미지" v-else-if="article.ATTACH_NO">
                            </div>
                            <div class="total-search__text">
                                <h4 class="title03" v-html="setHighlightText(article.TITLE)"></h4>
                                <p v-html="setHighlightText($commonUtils.removeTags(article.CONTENT))"></p>
                                <sub>
                                    {{ article.pathName }}
                                </sub>
                            </div>
                        </router-link>
                    </li>
                </ul>

                <!-- 건강정보 단독일때 -->
                <template v-if="selectTab === 'health'">
                    <kr_Pagination :totCnt="pageTotCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
                </template>
            </div>
        </div>

        <!-- 병원소개 -->
        <div class="total-search__box" v-if="introResult.totCnt !== 0 && (selectTab === 'total' || selectTab === 'intro')">
            <div class="total-search__header">
                <h4 class="title03">병원소개 (총 {{introResult.totCnt}}건)</h4>
                <a href="javascript:;" class="total-search__header--link" @click="moveTab('intro')" v-if="searchType === 'total'">더보기</a>
            </div>
            <div class="total-search__body">
                <ul class="total-search__list">
                    <li class="total-search__item" v-for="(article, index) in introResult.list" :key="index">
                        <router-link :to="article.link" class="total-search__item--link">
                            <div class="total-search__text">
                                <h4 class="title03" v-html="setHighlightText(article.TITLE)"></h4>
                                <p v-html="setHighlightText($commonUtils.removeTags(article.CONTENT))"></p>
                                <sub>
                                    {{ article.pathName }}
                                </sub>
                            </div>
                        </router-link>
                    </li>
                </ul>

                <template v-if="selectTab !== 'total'">
                    <kr_Pagination :totCnt="pageTotCnt" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount" @setNum="setNum"/>
                </template>
            </div>
        </div>
    </div>


</template>

<script>
    import SlideUpDown from 'vue-slide-up-down'
    import Search from '../../common/SearchBox.vue'

    export default {
        components: {
            SlideUpDown,
            Search
        },
        data() {
            return {
                pageTotCnt: 0,
                searchKeyword: this.$route.query.searchKeyword,
                inSearchKeyword: '',
                activeIndex: '0',
                searchType: 'total',
                totCnt: 0,
                centerResult: { totCnt: 0 },
                doctorResult: { totCnt: 0 },
                reserveResult: { totCnt: 0 },
                infoResult: { totCnt: 0 },
                healthResult: { totCnt: 0 },
                introResult: { totCnt: 0 },
                selectTab: 'total',
                consonantList: [],
                currentNum: 1,
                pageRow: 10,
                pageCount: window.innerWidth > 720 ? 10 : 5,
                searchChosung: '',
                searchKeywordText: '',
                inSearchKeywordText: '',
                inSearch: false,
                hashTags: [],
                searching: false,
                searchingKeyword: '',
                chosungs: '',
            };
        },
        watch: {
            '$route.query.searchKeyword'(value){
                console.log('wtach:', value)
                this.searchKeyword = value
                this.searchKeywordText = this.searchKeyword
                this.search(this.searchKeyword)
            }
        },
        mounted() {
            this.searchKeywordText = this.searchKeyword
            this.search(this.searchKeyword)
            document.addEventListener('click', this.handleClickOutside);
            this.getHashTags()
        },
        beforeDestroy() {
            document.removeEventListener('click', this.handleClickOutside);
        },
        methods: {
            getDoctorReserveDate(doctor, type){
                this.axios.get(this.api.doctor.getDate, {
                    params: {
                        drSid: doctor.drSid
                    }
                })
                .then(res => {
                    const data = res.data
                    if(data.code == 'OK'){
                        if(type == 'N'){
                            this.$store.state.reserveStore.normalReserve = doctor
                        }
                        if(type == 'Q'){
                            this.$store.state.reserveStore.quickReserve = doctor
                        }
                        this.$store.state.patInfoStore = {}
                        this.$router.push('/kr/reserve/reservation')
                    }else{
                        alert(data.result)
                        if(data.code == 'not login'){
                            this.$router.push('/kr/login')
                        }
                    }
                })
            },
            toggle(index) {
                console.log(index);
                this.activeIndex = this.activeIndex === index ? null : index;
                console.log(this.activeIndex)
            },
            // handleClickOutside(event) {
            //     const isClickInside = this.$el.contains(event.target);
            //     if (!isClickInside) {
            //         this.activeIndex = null;
            //     }
            // },
            searchEvent() {
                if (this.inSearch) {
                    this.inSearchKeyword = this.inSearchKeywordText
                } else {
                    this.inSearchKeyword = ''
                }
                this.search(this.searchKeywordText)
            },
            search(keyword) {
                this.searching = true
                this.searchingKeyword = keyword
                this.searchKeywordText = keyword
                this.$router.replace({
                    path: this.$route.path,
                    query: {searchKeyword: keyword}
                })
                if (keyword === '' || keyword === undefined) {
                    this.initTotalCount()
                    return false
                }
                const startCount = this.currentNum * this.pageRow - this.pageRow

                this.axios.get(this.api.search.aortaSearch, {
                    params: {
                        query: keyword,
                        menu: this.searchType,
                        startCount: startCount,
                        chosungs: this.searchChosung,
                        requery: this.inSearchKeyword,
                        hospId: this.$store.getters.getHost
                    }
                }).then(res => {
                    window.scrollTo(0, 0)
                    const searchResult = res.data

                    if (this.searchType === 'center' || this.searchType === 'total') {
                        this.centerResult.totCnt = searchResult.centerCount
                        this.centerResult.list = searchResult.centerList

                        if (this.searchType === 'center') {
                            this.pageTotCnt = searchResult.centerCount
                        }
                    }

                    if (this.searchType === 'doctor' || this.searchType === 'total') {
                        this.doctorResult.totCnt = searchResult.doctorCount
                        this.doctorResult.list = searchResult.doctorList
                        this.chosung = searchResult.consonantList
                        this.getDoctorConsonant()

                        if (this.searchType === 'doctor') {
                            this.chosung = searchResult.consonantList
                            this.getDoctorConsonant()
                            this.pageTotCnt = searchResult.doctorCount
                        }
                    }

                    if (this.searchType === 'info' || this.searchType === 'total') {
                        this.infoResult.totCnt = searchResult.infoCount
                        this.infoResult.list = searchResult.infoList

                        if (this.searchType === 'info') {
                            this.pageTotCnt = searchResult.infoCount
                        }
                    }

                    if (this.searchType === 'health' || this.searchType === 'total') {
                        this.healthResult.totCnt = searchResult.healthCount
                        this.healthResult.list = searchResult.healthList

                        if (this.searchType === 'health') {
                            this.pageTotCnt = searchResult.healthCount
                        }
                    }

                    if (this.searchType === 'intro' || this.searchType === 'total') {
                        this.introResult.totCnt = searchResult.introCount
                        this.introResult.list = searchResult.introList

                        if (this.searchType === 'intro') {
                            this.pageTotCnt = searchResult.introCount
                        }
                    }

                    if (this.searchType === 'reserve' || this.searchType === 'total') {
                        this.reserveResult.totCnt = searchResult.reserveCount
                        this.reserveResult.list = searchResult.reserveList

                        if (this.searchType === 'reserve') {
                            this.pageTotCnt = searchResult.reserveCount
                        }
                    }

                    if (this.selectTab === 'total') {
                        this.totCnt = this.centerResult.totCnt + this.doctorResult.totCnt + this.infoResult.totCnt + this.healthResult.totCnt + this.introResult.totCnt + this.reserveResult.totCnt
                    }

                    this.searching = false
                    this.searchKeyword = keyword

                })
            },
            moveTab(type) {
                this.selectTab = type
                this.searchType = type
                this.searchChosung = ''

                this.search(this.searchKeyword)
            },
            getDoctorConsonant() {
                this.consonantList = [
                    { cho: 'ㄱ~ㄷ', disable: 'disable', choList: ['ㄱ', 'ㄴ', 'ㄷ'], searchText: 'ㄱ,ㄴ,ㄷ' },
                    { cho: 'ㄹ~ㅂ', disable: 'disable', choList: ['ㄹ', 'ㅁ', 'ㅂ'], searchText: 'ㄹ,ㅁ,ㅂ' },
                    { cho: 'ㅅ~ㅊ', disable: 'disable', choList: ['ㅅ', 'ㅇ', 'ㅈ', 'ㅊ'], searchText: 'ㅅ,ㅇ,ㅈ,ㅊ' },
                    { cho: 'ㅋ~ㅎ', disable: 'disable', choList: ['ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'], searchText: 'ㅋ,ㅌ,ㅍ,ㅎ' },
                ]
                for (let i of this.consonantList) {
                    for (let j of this.chosung) {
                        if (i.choList.includes(j)) {
                            i.disable = ''
                        }
                    }
                }
            },
            searchConsonant(consonant) {
                this.searchChosung = consonant
                this.currentNum = 1
                this.drName = ''
                this.search(this.searchKeyword)
            },
            setNum(n) {
                this.currentNum = n

                this.search(this.searchKeyword)
            },
            clearSearch() {
                this.inSearch = false
                this.inSearchKeyword = ''
                this.inSearchKeywordText = ''
                this.searchKeywordText = ''
                this.search(this.searchKeyword)
            },
            getHashTags() {
                this.axios.get(this.api.search.hashKeywords, {
                    params: {
                        hospId: this.$store.getters.getHost
                    }
                }).then(res => {
                    this.hashTags = res.data.result
                    if(this.hashTags && this.hashTags.length > 0){
                        this.hashTags = this.hashTags.filter(item => item.useYn == 'Y')
                    }
                })
            },
            setHighlightText(text) {
                let result = text.replace(new RegExp((this.searchKeyword), 'g'), `<span class="mark">${this.searchKeyword}</span>`)
                if(this.inSearchKeyword) {
                    result = result.replace(new RegExp((this.inSearchKeyword), 'g'), `<span class="mark">${this.inSearchKeyword}</span>`)
                }
                return result
            },
            initTotalCount() {
                this.centerResult = { totCnt: 0 }
                this.doctorResult = { totCnt: 0 }
                this.reserveResult = { totCnt: 0 }
                this.infoResult = { totCnt: 0 }
                this.healthResult = { totCnt: 0 }
                this.introResult = { totCnt: 0 }
                this.searching = false
            }
        }
    };
</script>